import React from "react";
import styled from "styled-components";
import { Button, Typography } from "@material-ui/core";
import * as PropTypes from "prop-types";
import { Link as GatsbyLink } from "gatsby";
import discoveryTourExplore from "./visual/discovery-tour-explore-OberionIO.png";
import discoveryTourTake from "./visual/discovery-tour-take-OberionIO.min.svg";
import discoveryTourTakeBackground from "./visual/discovery-tour-take-background-OberionIO.min.svg";
import listCeleste from "../home/visual/discover-indie-games-OberionIO-2x.png";
import tryRandomBackground from "./visual/try-random-background-OberionIO.min.svg";
import tryRandomRobot from "./visual/try-random-robot-OberionIO.min.svg";
import { GrowDiv } from "./AccountStats";
import { ButtonRoute, ROUTES } from "../navigation/InternalRoute";


const HeroBannerDiv = styled.div`
  width: 100%;
  height: ${props => props.illustrationHeight};
  background-image: url(${props => props.background});
  background-size: cover;
  
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;
// TODO merge with HeroBannerDiv
const HeroBannerDiv2 = styled.div`
  margin: 4rem 0 -2rem 0;
  width: 100%;
  height: ${props => props.illustrationHeight};
  
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

export const DiscoveryTourExplore = ({ illustrationHeight }) => (
  <HeroBannerDiv illustrationHeight={illustrationHeight} background={discoveryTourExplore}>
    <Typography variant="h6" gutterBottom>Take a Discovery Tour</Typography>
    <Button href="#" variant="contained" color="secondary">Explore</Button>
  </HeroBannerDiv>
); // TODO button href setzen
DiscoveryTourExplore.propTypes = {
  illustrationHeight: PropTypes.string.isRequired,
};


const DiscoveryTourTakeDiv = styled(HeroBannerDiv)`
  background: 
    url(${discoveryTourTake}) left bottom no-repeat, 
    url(${discoveryTourTakeBackground}) no-repeat center;
  background-size: contain, cover;
`;
const TextDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  margin-bottom: 5rem;
`;
const RestrictedTypography = styled(Typography)`
  max-width: 9.5rem;
  margin-right: 1rem;
`;
export const DiscoveryTourTake = ({ illustrationHeight }) => (
  <DiscoveryTourTakeDiv illustrationHeight={illustrationHeight} background={discoveryTourTake}>
    <TextDiv>
      <GrowDiv />
      <RestrictedTypography variant="h6" align="right">Take a Discovery Tour</RestrictedTypography>
    </TextDiv>
  </DiscoveryTourTakeDiv>
);
DiscoveryTourTake.propTypes = {
  illustrationHeight: PropTypes.string.isRequired,
};

const TryRandomDiv = styled(HeroBannerDiv)`
  background: 
    url(${tryRandomRobot}) left bottom no-repeat, 
    url(${tryRandomBackground}) no-repeat center;
  background-size: ${props => props.illustrationHeight}, cover;
`;
export const TryRandom = ({ illustrationHeight }) => (
  <TryRandomDiv illustrationHeight={illustrationHeight} background={tryRandomBackground}>
    <TextDiv>
      <GrowDiv />
      <RestrictedTypography variant="h6" align="right">Try Something Random</RestrictedTypography>
    </TextDiv>
  </TryRandomDiv>
);
TryRandom.propTypes = {
  illustrationHeight: PropTypes.string.isRequired,
};

const ButtonRouteTopMargin = styled(ButtonRoute)`
  margin-top: 5rem;
`;
export const CelesteCompilation = ({ illustrationHeight }) => (
  <HeroBannerDiv illustrationHeight={illustrationHeight} background={listCeleste}>
    <ButtonRouteTopMargin as={GatsbyLink} to={ROUTES.LISTS.CELESTE.TO}>
      <Button variant="contained" color="secondary">Discovery Tour Preview</Button>
    </ButtonRouteTopMargin>
  </HeroBannerDiv>
);
CelesteCompilation.propTypes = {
  illustrationHeight: PropTypes.string.isRequired,
};

export const GamingLibrary = ({ illustrationHeight }) => {
  const text = "What's coming next for this page";
  return (
    <HeroBannerDiv illustrationHeight={illustrationHeight} background={discoveryTourExplore}>
      <Typography variant="h6" align="center" gutterBottom>{text}</Typography>
      <ButtonRoute as={GatsbyLink} to={ROUTES.LIBRARY.TO}>
        <Button variant="contained" color="secondary">Library Preview</Button>
      </ButtonRoute>
    </HeroBannerDiv>
  );
};
GamingLibrary.propTypes = {
  illustrationHeight: PropTypes.string.isRequired,
};

export const PreviewExplanation = () => {
  const text = "Take a look at our upcoming features";
  return (
    <HeroBannerDiv2>
      <Typography variant="h6" align="center" gutterBottom>{text}</Typography>
    </HeroBannerDiv2>
  );
};
